export const ROLES = {
  admin: 'admin',
  doctor: 'doctor',
  nurse: 'nurse',
  admission: 'admission',
  patient: 'patient',
};

export const roleLabels = {
  [ROLES.admin]: 'Administrador',
  [ROLES.doctor]: 'Medico',
  [ROLES.nurse]: 'Enfermeria',
  [ROLES.admission]: 'Admision',
  [ROLES.patient]: 'Paciente',
};

export const internalRoles = [ROLES.admin, ROLES.doctor, ROLES.nurse, ROLES.admission];

export const rolePermissions = {
  [ROLES.admin]: [
    'dashboard.admin',
    'users.manage',
    'patients.read',
    'patients.write',
    'appointments.read',
    'appointments.write',
    'clinical.records.read',
    'clinical.records.write',
    'consents.read',
    'reports.read',
    'settings.manage',
  ],
  [ROLES.doctor]: [
    'dashboard.doctor',
    'patients.read',
    'appointments.read',
    'appointments.write',
    'clinical.records.read',
    'clinical.records.write',
    'consultation.join',
    'diagnosis.write',
    'consents.read',
  ],
  [ROLES.nurse]: [
    'dashboard.nurse',
    'patients.read',
    'patients.write',
    'appointments.read',
    'clinical.records.read',
    'vitals.write',
    'consents.read',
  ],
  [ROLES.admission]: [
    'dashboard.admission',
    'patients.read',
    'patients.write',
    'appointments.read',
    'appointments.write',
    'consents.read',
  ],
  [ROLES.patient]: [
    'dashboard.patient',
    'profile.read',
    'profile.write',
    'appointments.read.own',
    'appointments.write.own',
    'clinical.records.read.own',
    'consents.write.own',
    'consultation.join',
  ],
};

export const roleModules = {
  [ROLES.admin]: [
    'Gestion de usuarios y roles',
    'Auditoria y configuracion',
    'Reportes ejecutivos',
    'Supervision de agenda y formularios MSP',
  ],
  [ROLES.doctor]: [
    'Agenda medica',
    'Teleconsulta',
    'HCU 002 y diagnosticos CIE-10',
    'Resumen clinico y seguimiento',
  ],
  [ROLES.nurse]: [
    'Ficha del paciente',
    'Signos vitales',
    'Apoyo a consulta',
    'Lectura de consentimientos',
  ],
  [ROLES.admission]: [
    'Admision virtual',
    'Ficha administrativa del paciente',
    'Agenda y estados de cita',
    'Verificacion de consentimiento',
  ],
  [ROLES.patient]: [
    'Portal del paciente',
    'Ficha personal',
    'Consentimiento informado',
    'Ingreso a teleconsulta',
  ],
};

export const hasPermission = (user, permission) => {
  if (!user?.role) return false;
  return rolePermissions[user.role]?.includes(permission) || false;
};

export const hasAnyPermission = (user, permissions) => permissions.some((permission) => hasPermission(user, permission));

export const isInternalRole = (role) => internalRoles.includes(role);

export const getPortalForRole = (role) => (role === ROLES.patient ? '/portal' : '/plataforma');

export const getDashboardForRole = (role) => (
  role === ROLES.patient ? '/portal/dashboard' : '/plataforma/dashboard'
);
